<div
  class="card-bid orange"
  *ngIf="
    !analizing_bid &&
    animal_obj.status !== 'VENDIDO' &&
    animal_obj.type === 'LEILAO ONLINE'
  "
>
  <div class="left">
    <h4>Próximo Lance</h4>
    <h1>{{ next_bid | currency : 'BRL' }}</h1>
  </div>

  <div class="right">
    <!-- Pre Lance -->
    <button
      mat-button
      class="c_white"
      (click)="openPopupPreBid()"
      *ngIf="!winning || user.type === 'MASTER'"
    >
      DAR PRÉ LANCE
    </button>
  </div>
</div>

<!-- PRE_LANCE - Lance Atual -->
<div
  class="card-bid"
  [ngClass]="!winning || user.type === 'MASTER' ? 'white' : 'white'"
  *ngIf="
    !analizing_bid &&
    list_bids.length > 0 &&
    !['VENDIDO'].includes(animal_obj.status)
  "
>
  <div class="left">
    <h4 *ngIf="!winning">Lance Atual</h4>
    <h4 *ngIf="winning">Seu lance esta vencendo!</h4>

    <div class="winning-bid">
      <i icon="check" *ngIf="winning"></i>
      <h5>
        <strong>{{ attual_bid | currency : 'BRL' }}</strong>
      </h5>
      <h5>{{ list_bids[0].updated_at | date : 'dd/MM/yyyy HH:mm a' }}</h5>
    </div>
  </div>
</div>
